import "core-js/modules/es.array.push.js";
import { computed, defineComponent, nextTick, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { delGroup, delGroup_all, getHistoryMsg as getHistoryMsgApi, saveGroup } from "@/service/chat";
import { Fold, Phone, Present } from "@element-plus/icons-vue";
import { ElMessageBox } from "element-plus";
import { onClickOutside } from "@vueuse/core";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  name: "Chat-Slider-Bar",
  components: {
    Fold,
    Phone,
    Present
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const sessions = computed(() => {
      return store.state.sessions;
    });
    const sessionActive = ref(-1);
    const showService = ref(false);
    const userInfo = computed(() => {
      return store.state.userInfo;
    });
    const isMobile = computed(() => {
      return store.state.isMobile;
    });
    const sliderShow = computed(() => {
      return store.state.showChatSlider;
    });
    const isLogin = computed(() => {
      return store.state.isLogin;
    });
    function initSessionList() {
      return store.dispatch("getSessions").then(() => {
        sessionActive.value = sessions.value[0]?.id;
        getHistoryMsg();
      });
    }
    function createAndEdit(title, id) {
      const tip = id ? "编辑会话" : "创建会话";
      ElMessageBox.prompt("请输入会话标题", tip, {
        inputValue: title,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        inputValidator(v) {
          if (!v) return "请输入会话标题";
        }
      }).then(({
        value
      }) => {
        if (route.name !== "chat") {
          router.push("chat");
        }
        saveGroup({
          id,
          title: value
        }).then(res => {
          if (!res.errno) {
            initSessionList();
          }
        });
      }).catch(() => {});
    }
    function getHistoryMsg() {
      store.commit("SET_HISTORY_LOADING", true);
      getHistoryMsgApi(sessionActive.value).then(res => {
        if (!res.errno) {
          store.commit("SET_CURRENT_CHAT_MSG", res.data.list);
        }
      }).finally(() => {
        store.commit("SET_HISTORY_LOADING", false);
      });
    }
    watch(sessionActive, v => {
      store.commit("SET_CURRENT_SESSION", v);
    }, {
      immediate: true
    });
    function toggle() {
      store.commit("SET_CHAT_SLIDER", !sliderShow.value);
    }
    const target = ref(null);
    onClickOutside(target, () => {
      if (isMobile.value && sliderShow.value) toggle();
    });
    onMounted(() => {
      setTimeout(async () => {
        if (route.name === "chat") {
          await saveGroup({
            title: "新的会话"
          });
        }
        initSessionList();
      });
    });
    function hideSliderBarOnMobile() {
      if (isMobile.value) store.commit("SET_CHAT_SLIDER", false);
    }
    return {
      route,
      target,
      isMobile,
      sliderShow,
      sessions,
      sessionActive,
      isLogin,
      download() {
        const filename = "云雾AI.url";
        const urlContent = `[InternetShortcut]
URL=${location.href}`;
        const blob = new Blob([urlContent], {
          type: "text/plain"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 100);
      },
      showVip() {
        hideSliderBarOnMobile();
        store.commit("SET_SHOW_VIP", true);
      },
      showService,
      showServiceDialog() {
        hideSliderBarOnMobile();
        showService.value = true;
      },
      userInfo,
      login() {
        store.commit("SET_SHOW_LOGIN", true);
      },
      showUserInfo() {
        hideSliderBarOnMobile();
        store.commit("SET_SHOW_USERINFO", true);
      },
      logout() {
        store.dispatch("logout");
      },
      toggle,
      create() {
        createAndEdit("新的会话");
      },
      edit({
        id,
        title
      }) {
        createAndEdit(title, id);
      },
      del(id) {
        ElMessageBox.confirm("删除后不可恢复，确认删除吗?", "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          delGroup({
            id
          }).then(res => {
            if (!res.errno) {
              initSessionList();
            }
          });
        }).catch(() => {});
      },
      changeSession(id) {
        hideSliderBarOnMobile();
        if (route.name !== "chat") {
          router.push("chat");
        }
        sessionActive.value = id;
        getHistoryMsg();
      },
      cleanAll() {
        hideSliderBarOnMobile();
        ElMessageBox.confirm("删除后不可恢复，确认删除吗?", "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          delGroup_all().then(res => {
            if (!res.errno) {
              initSessionList();
            }
          });
        }).catch(() => {});
      }
    };
  }
});